<template>
  <div
    class="sidebar vh-100 h-100"
    :class="{
      'sidebar--open': sidebarOpen
    }"
  >
    <ToggleSidebar />
    <div class="sidebar__content h-100">
      <div class="sidebar__elements h-100">
        <AppLogo />
        <UserInfo />
        <MainMenu />
      </div>
    </div>
  </div>
</template>

<script>
import ToggleSidebar from '@/components/shared/toggle-sidebar';
import AppLogo from '@/components/shared/logo';
import UserInfo from '@/components/shared/user-info';
import MainMenu from '@/components/shared/main-menu';

export default {
  name: 'AppSidebar',
  components: {
    ToggleSidebar,
    AppLogo,
    UserInfo,
    MainMenu
  },
  computed: {
    sidebarOpen() {
      return this.$store.state.sidebarOpen;
    }
  },
  watch: {
    $route() {
      this.hideIfShowWide();
    }
  },
  mounted() {
    this.hideIfShowWide();
  },
  methods: {
    hideIfShowWide() {
      if ((this.$route.meta.showWide || this.$mq === 'sm') && this.$store.state.sidebarOpen) {
        this.$store.dispatch('toggleSidebar');
      }
    }
  }
};
</script>
